module.exports = __webpack_public_path__ + "static/media/uaic-building.540e404b.png";